import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSidebarFloating"><Path d="M18.25 4.75H5.75C4.09315 4.75 2.75 6.09315 2.75 7.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H18.25C19.9069 19.25 21.25 17.9069 21.25 16.25V7.75C21.25 6.09315 19.9069 4.75 18.25 4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Rect x="14.5" y="10.5" width="4" height="6" rx="0.745" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
